import {CONSTANTS} from "../../common/constants";
import Checkbox from "@mui/material/Checkbox";
import React, {useContext, useEffect, useState} from "react";
import {displayPhone, formatAge, handleDefaultValues, sortAttendeesFunction, isValidDob, DOB_INPUT_MIN, DOB_INPUT_MAX} from "../../common/Utils";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import MDButton from "../../../components/MDButton";
import {Grid, NativeSelect} from "@mui/material";
import {getCustomerFamilyAll, getFamilyMemberTypes} from "../../common/api/WebApi";
import {Col, Container, Row} from "react-bootstrap";
import MDInput from "../../../components/MDInput";
import {useForm} from "react-hook-form";
import {AppContext} from "../../../lib/AppContext";
import {saveMyCustomerFamily} from "../../common/api/PortalCustomerApi";
import {UserContext} from "../../../lib/UserProvider";
import Loading from "../../common/Loading";


export default function LockedAccountForm({
                                            inventory,
                                            siblingQuantity,
                                            callback,
                                            addFamilyCallback,
                                            doSubmit
                                          }) {

  const [userContext, setUserContext] = useContext(UserContext);
  const [authenticated, setAuthenticated] = useState(userContext?.sessionUser?.guid?.length > 0);
  const [formReady, setFormReady] = useState(false);

  useEffect(() => {
    setAuthenticated(userContext?.sessionUser?.guid?.length > 0);
  }, [userContext]);

  const [membershipMemberAdults, setMembershipMemberAdults] = useState([]);
  const [membershipMemberChildren, setMembershipMemberChildren] = useState([]);
  const [membershipMembers, setMembershipMembers] = useState([]);
  const [addFamily, setAddFamily] = useState(false);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [savingFamilyMember, setSavingFamilyMember] = useState(false);
  const [context, setContext] = useContext(AppContext);

  const [loadingFamily, setLoadingFamily] = useState(true);

  useEffect(() => {
    addFamilyCallback(addFamily);
    if (addFamily) {
      setFormReady(true);
    }
  }, [addFamily]);

  const doGetCustomerFamily = () => {
    setLoadingFamily(true);
    getCustomerFamilyAll().then((resp) => {
      setFamilyMembers(resp);
      setLoadingFamily(false);
    })
  }
  useEffect(() => {
    doGetCustomerFamily()
  }, []);

  useEffect(() => {
    setMembershipMemberChildren([]);
  }, [siblingQuantity]);

  useEffect(() => {
    callback({
      membershipMembers: membershipMembers,
      numAssignedAdults: membershipMemberAdults?.length || 0,
      numAssignedChildren: membershipMemberChildren?.length || 0
    })
  }, [membershipMembers, membershipMemberAdults, membershipMemberChildren]);

  useEffect(() => {
    setMembershipMembers(inventory?.membershipMembers);
  }, [inventory?.membershipMembers]);

  useEffect(() => {
    let arr = [];
    for (let j in membershipMemberAdults) {
      arr.push(membershipMemberAdults[j]);
    }
    for (let j in membershipMemberChildren) {
      arr.push(membershipMemberChildren[j]);
    }
    setMembershipMembers(arr);
  }, [membershipMemberAdults, membershipMemberChildren]);

  useEffect(() => {
    if (inventory?.membershipMembers?.length === 0) {
      return;
    }
    if (familyMembers?.length === 0) {
      return;
    }

    let memberChildren = [];
    let memberAdults = [];

    for (const ff in inventory?.membershipMembers) {
      for (const f in familyMembers) {
        if (inventory?.membershipMembers[ff] === familyMembers[f]?.guid) {
          if (familyMembers[f].familyMemberType?.id === CONSTANTS.FAMILY_MEMBER_TYPE.CHILD) {
            memberChildren.push(familyMembers[f].guid);
          } else {
            memberAdults.push(familyMembers[f].guid);
          }
        }
      }
      setMembershipMemberChildren(memberChildren);
      setMembershipMemberAdults(memberAdults);
    }

  }, [inventory, familyMembers]);

  const toggleAdults = (guid) => {
    setMembershipMemberAdults(prev =>
      prev.includes(guid)
        ? prev.filter(id => id !== guid)
        : [...prev, guid]
    );
  };

  const toggleChildren = (guid) => {
    setMembershipMemberChildren(prev =>
      prev.includes(guid)
        ? prev.filter(id => id !== guid)
        : [...prev, guid]
    );
  };

  const handleSaveFamilyMember = async (member) => {
    setSavingFamilyMember(true);
    let result = await saveMyCustomerFamily(member);
    setSavingFamilyMember(false);
    setAddFamily(false);
    doGetCustomerFamily();
  }

  const [isChild, setIsChild] = useState(false);

  const [emergencyContact, setEmergencyContact] = useState();
  const [familyMemberTypes, setFamilyMemberTypes] = useState([]);
  const [typesReady, setTypesReady] = useState(false);

  const [dobReady, setDobReady] = useState(false);
  useEffect(() => {
    setIsChild(true);
  }, []);

  const [isNew, setIsNew] = useState(true);

  useEffect(() => {
    getFamilyMemberTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setFamilyMemberTypes(result);
        setTypesReady(true);
      }
    });
  }, []);

  useEffect(() => {
    if (typesReady && isNew) {
      setValue('familyMemberType.id', 1);
      setIsChild(true);
    }
  }, [isNew, typesReady])

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: {errors},
  } = useForm({
    values: handleDefaultValues({}),
  });


  const handleSaveFamilyMemberFn = (data) => {
    let _d = {...data};
    handleSaveFamilyMember(_d);
  };

  useEffect(()=> {
    if (formReady) {
      handleSubmit(handleSaveFamilyMemberFn)();
    }
  }, [doSubmit]);

  const toggleEmergencyContact = (e) => {
    setEmergencyContact(e.target.checked);
  };

  return (<>
    <div style={{
      display: 'block',
      margin: '10px 0'
    }}>

      {addFamily && <>
        <form method={"POST"} onSubmit={handleSubmit(handleSaveFamilyMemberFn)} id={'lockedAccountMemberForm'}>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="firstName">First Name</label>
                      <MDInput
                        variant="outlined" type="text" required
                        {...register('firstName', {
                          required: true
                        })}
                        className="form-control" id="firstName"
                        placeholder="Enter First name"/>
                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="lastName">Last Name</label>
                      <MDInput
                        variant="outlined" type="text" required
                        {...register('lastName', {
                          required: true
                        })}
                        className="form-control" id="lastName"
                        placeholder="Enter Last name"/>
                    </div>
                  </Col>
                </Row>


                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="state">Family Member Type</label>
                      {typesReady && <NativeSelect required
                                                   id={'familyMemberType'}
                                                   variant="outlined"
                                                   name={'familyMemberType'} className={'form-control'}
                                                   {...register('familyMemberType.id', {
                                                     required: true,
                                                     min: 1,
                                                     onChange: ((e) => {
                                                       setIsChild(parseInt(e.target.value, 10) === 1)
                                                     })
                                                   })} >
                        {
                          familyMemberTypes.map((c) =>
                            <option value={c.id} key={c.id}>
                              {c.name}
                            </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>

                  <Col className={'col'} sm={4} xs={8}>

                    {isChild &&
                      <div className="form-group">
                        <label htmlFor="dob">Birth Date</label>
                        <div>
                          <input
                            required={isChild}
                            {...register('dob', {
                              required: isChild,
                              validate: (value) => !isChild || isValidDob(value) || 'Please enter a valid birth date'
                            })}
                            className={`form-control${errors.dob ? ' is-invalid' : ''}`}
                            type="date"
                            min={DOB_INPUT_MIN}
                            max={DOB_INPUT_MAX}
                          />
                        </div>
                        {errors.dob && <div className="invalid-feedback d-block">{errors.dob.message}</div>}
                      </div>
                    } &nbsp;

                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={6}>

                    {!isChild &&
                      <label htmlFor="emergencyContact" className={'mt-4'}>
                        <input type="checkbox"
                               {...register('emergencyContact',
                                 {
                                   onChange: (e) => {
                                     toggleEmergencyContact(e);
                                   }
                                 })}
                               id="emergencyContact"/>
                        &nbsp;Emergency Contact
                      </label>
                    } &nbsp;

                  </Col>
                </Row>
                {emergencyContact &&
                  <Row className={'my-2'}>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <label htmlFor="phoneNumber">Emergency Phone</label>
                        <MDInput
                          variant="outlined" type="text"
                          {...register('phoneNumber', {
                            onChange: (e) => {
                              e.target.value = displayPhone(e.target.value);
                            }
                          })}
                          className="form-control" id="phoneNumber"
                          placeholder="Enter Emergency Phone"/>
                      </div>
                    </Col>
                  </Row>
                }

              </Container>
            </Col>
          </Row>
        </form>
      </>}
      {!addFamily && <>
        <h5>{inventory?.name} - Assign Members</h5>
        {loadingFamily && <Loading />}
        {familyMembers?.length > 0 && <>
          {inventory?.accountType?.familyPass && <div>
            {inventory?.numAdults > 0 && <div className={'d-block mb-4'}>
              <p><b>Assign up to {inventory?.numAdults} Adults</b></p>
              <ul className={'list-group'}>
                {familyMembers.sort(sortAttendeesFunction).filter((f) => f.familyMemberType?.id !== CONSTANTS.FAMILY_MEMBER_TYPE.CHILD).map((f, idx) => {
                  return (<li key={idx} className={'list-group-item'} style={{
                      background: (!membershipMemberAdults.includes(f.guid) && membershipMemberAdults?.length === ((inventory.numAdults ? inventory.numAdults : 0)) ? '#eaeaea' : '#fff')
                    }}>
                      <Checkbox checked={membershipMemberAdults.includes(f.guid)}
                                disabled={!membershipMemberAdults.includes(f.guid) && membershipMemberAdults?.length === inventory.numAdults}
                                onChange={() => {
                                  toggleAdults(f.guid);
                                }}
                      />&nbsp;
                      {f.firstName} {f.lastName}
                    </li>
                  )
                })
                }
              </ul>
            </div>}

            {inventory?.numChildren > 0 && <div className={'d-block mb-2'}>
              <p><b>Assign up to {inventory?.numChildren} Children</b></p>
              <ul className={'list-group'}>
                {familyMembers.sort(sortAttendeesFunction).filter((f) => f.familyMemberType?.id === CONSTANTS.FAMILY_MEMBER_TYPE.CHILD).map((f, idx) => {
                  return (<li key={idx} className={'list-group-item'} style={{
                      background: (!membershipMemberChildren.includes(f.guid) && membershipMemberChildren?.length === ((inventory.numChildren ? inventory.numChildren : 0)) ? '#eaeaea' : '#fff')
                    }}>
                      <Checkbox checked={membershipMemberChildren.includes(f.guid)}
                                disabled={!membershipMemberChildren.includes(f.guid) && membershipMemberChildren?.length === inventory.numChildren}
                                onChange={() => {
                                  toggleChildren(f.guid);
                                }}
                      />&nbsp;
                      {f.firstName} {f.lastName} <span
                      className={'font-smaller'}>{f?.dob && ' (' + formatAge(f) + ')'}</span>
                    </li>
                  )
                })
                }
              </ul>
            </div>}

          </div>}


          {!inventory?.accountType?.familyPass && <div>
            <div className={'d-block mb-2'}>
              <ul className={'list-group'}>
                {familyMembers.sort(sortAttendeesFunction).filter((f) => f.familyMemberType?.id === CONSTANTS.FAMILY_MEMBER_TYPE.CHILD).map((f, idx) => {
                  return (<li key={idx} className={'list-group-item'} style={{
                      background: (!membershipMemberChildren.includes(f.guid) && membershipMemberChildren?.length >= ((siblingQuantity ? siblingQuantity : 0)) ? '#eaeaea' : '#fff')
                    }}>
                      <Checkbox checked={membershipMemberChildren.includes(f.guid)}
                                disabled={!membershipMemberChildren.includes(f.guid) && membershipMemberChildren?.length >= (siblingQuantity ? siblingQuantity : 0)}
                                onChange={() => {
                                  toggleChildren(f.guid);
                                }}
                      />&nbsp;
                      {f.firstName} {f.lastName} <span
                      className={'font-smaller'}>{f?.dob && ' (' + formatAge(f) + ')'}</span>
                    </li>
                  )
                })
                }
              </ul>
            </div>
          </div>}
        </>}

        {!loadingFamily && authenticated && <Grid item xs={12}>
                                  <span className={'pull-right'}>
                                    <MDButton
                                      variant="outlined"
                                      color="secondary"
                                      size="small"
                                      onClick={() => {
                                        setAddFamily(true);
                                      }}>
                                    <PersonAddIcon/>&nbsp;Add Family Member
                                  </MDButton>
                                </span>
        </Grid>}

      </>
      }

    </div>

  </>)
}